import { render, staticRenderFns } from "./AttachmentsInfo.vue?vue&type=template&id=5901560f&scoped=true&"
import script from "./AttachmentsInfo.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsInfo.vue?vue&type=style&index=0&id=5901560f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901560f",
  null
  
)

export default component.exports